import { ConvertMillimetersToCentimeters, ConvertCentimetersToMillimeters } from '@/utils/converters';

function transformItem2Dto(item) {
  const dto = {
    ...item,
    productGroupID: item.id,
    defaultTopFinishMeasurementInMm: ConvertCentimetersToMillimeters(item.defaultTopFinishMeasurementInCm),
    defaultSideFinishMeasurementInMm: ConvertCentimetersToMillimeters(item.defaultSideFinishMeasurementInCm),
    defaultBottomFinishMeasurementInMm: ConvertCentimetersToMillimeters(item.defaultBottomFinishMeasurementInCm)
  };
  delete dto.id;
  delete dto.defaultTopFinishMeasurementInCm;
  delete dto.defaultSideFinishMeasurementInCm;
  delete dto.defaultBottomFinishMeasurementInCm;
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    ...dto,
    id: dto.productGroupID,
    defaultTopFinishMeasurementInCm: ConvertMillimetersToCentimeters(dto.defaultTopFinishMeasurementInMm),
    defaultSideFinishMeasurementInCm: ConvertMillimetersToCentimeters(dto.defaultSideFinishMeasurementInMm),
    defaultBottomFinishMeasurementInCm: ConvertMillimetersToCentimeters(dto.defaultBottomFinishMeasurementInMm)
  };
  delete item.productGroupID;
  delete item.defaultTopFinishMeasurementInMm;
  delete item.defaultSideFinishMeasurementInMm;
  delete item.defaultBottomFinishMeasurementInMm;
  return item;
}

export const apiOverrides = { transformItem2Dto, transformDto2Item };
